// extracted by mini-css-extract-plugin
export default {"zoomControls":"Lea-z","zoomControlButton":"Mea-z","zoomBanner":"Nea-z","bannerButton":"Oea-z","imageButton":"Pea-z","zoom":"Qea-z","zoomContent":"Rea-z"};